import { render, staticRenderFns } from "./PaginationViewer.vue?vue&type=template&id=6d8f64a2"
import script from "./PaginationViewer.vue?vue&type=script&lang=js"
export * from "./PaginationViewer.vue?vue&type=script&lang=js"
import style0 from "./PaginationViewer.vue?vue&type=style&index=0&id=6d8f64a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports